<template>
  <div>
    <transition name="mainContainer" :appear="true">
      <div :class="classObj">
        <navbar class="absolute" style="z-index: 99999" />
        <div class="app-wrapper relative">
          <sidebar class="sidebar-container dark" />
          <div class="main-container">
            <div :class="{ 'fixed-header': 0 }">
              <tags-view />
            </div>
            <app-main />
          </div>
        </div>
      </div>
    </transition>

    <!-- 通知查看弹窗 -->
    <element-dialog
      :title="title"
      v-model="showDialog"
      ref="elementDialog"
      @submit="handleSubmit"
      :show-footer="false"
    >
      <el-form
        ref="myform"
        :model="form"
        label-width="8.75rem"
        class="flex_row_a flex_wrap dialogForm"
      >
        <el-form-item label="接收时间">
          <el-input v-model="form.eventReceiveTime"></el-input>
        </el-form-item>

        <el-form-item label="调节类型">
          <el-input v-model="form.controlType"
        /></el-form-item>

        <el-form-item label="需求类型">
          <el-input v-model="form.commandType" />
        </el-form-item>

        <el-form-item label="需求值">
          <el-input v-model="form.commandValue"></el-input>
        </el-form-item>

        <el-form-item label="开始时间">
          <el-input v-model="form.startTime"></el-input>
        </el-form-item>

        <el-form-item label="结束时间">
          <el-input v-model="form.endTime"></el-input>
        </el-form-item>

        <div class="width100 flex_row_c margin-bottom-15 margin-top-10">
          <el-button type="primary" @click="openNewDialog" size="mini"
            >用户下控</el-button
          >
          <!-- <el-button type="danger" @click="handleCancel" size="mini"
            >控制回绝</el-button
          > -->
        </div>
      </el-form>
    </element-dialog>

    <!-- 用户控制弹窗 -->
    <element-dialog
      :title="userTitle"
      v-model="userShowDialog"
      ref="elementDialog"
      :show-footer="false"
    >
      <el-form
        ref="myform"
        label-width="8.75rem"
        class="flex_row_a flex_wrap dialogForm"
      >
        <div class="width100 text-align-right">
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="Decomposition"
            >自动分解</el-button
          >
        </div>

        <div
          class="margin-top-10 width100"
          :style="{
            height: 'calc(100% - 4.5rem)',
          }"
        >
          <element-table
            :tableData="tableData"
            :tableColumns="tableColumns"
            :showSelect="true"
            :showIndex="false"
            :pagination="false"
            @selectionChange="selectionChange"
            @child_event="handleChildEvent"
            @cell-dblclick="doubleClick"
          >
          </element-table>

          <div class="width100 flex_row_c margin-bottom-15 margin-top-20">
            <el-button type="primary" @click="handleSubmit" size="mini"
              >控制下发</el-button
            >
            <!-- <el-button type="danger" @click="CancelControl" size="mini"
              >取消控制</el-button
            > -->
          </div>
        </div>
      </el-form>
    </element-dialog>
    <websocketMessage></websocketMessage>
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar, TagsView } from './components';
import { mapState } from 'vuex';
import * as Server from './server';
import editTable from '@/components/EditTable/index.vue';
import HttpUrl from '@/api/ancillary-services/eventCalendar.js';
import elementTable from '@/components/ElementTable/index_lx.vue';
import elementDialog from '@/components/ElementDialog/index.vue';
import { localStorageUtil } from '@/utils/storage-util';
import StompService from '@/utils/websocket.js';
import websocketMessage from '@/components/WebsocketBox/message.vue';

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    TagsView,
    elementTable,
    elementDialog,
    editTable,
    websocketMessage,
  },
  data() {
    return {
      consIds: [],
      EventID: '',
      screenWidth: null,
      // 弹窗
      title: '',
      userTitle: '',
      showDialog: false,
      userShowDialog: false,
      form: {
        receive: '',
        adjust: '',
        demand: '',
        demandValue: '',
        startTime: '',
        endTime: '',
      },
      // 表格
      tableDataSelectOptions: [],
      tableData: [],
      tableDataDialog: [],
      tableColumns: Server.tableColumns,
      tableColumnsDialog: [],
      baseUrl: 'ws://10.100.10.60:30550/ws',
      stompService: null,
    };
  },
  created() {
    this.stompService = new StompService('http://10.100.10.60:30132/ws');
    this.stompService.connect();
    this.stompService.subscribe('/topic/event/update', (task) => {
      this.setSessionItem('websocketInform', JSON.stringify(task));
    });
  },
  beforeDestroy() {
    this.stompService?.disconnect();
  },
  mounted() {
    const eventSource = new EventSource('/api/DR/cityEventInfo/sse');
    eventSource.onmessage = (event) => {
      let message = JSON.parse(event.data);
      this.form = message.data;
      this.EventID = message.data.eventId;
      this.form.eventReceiveTime = this.getDateTimeSecond(
        this.form.eventReceiveTime,
      );
      // this.$confirm('您有一个新的控制事件', '通知消息', {
      //   closeOnClickModal: false,
      //   confirmButtonText: '查看',
      //   cancelButtonText: '收起',
      // })
      //   .then(() => {
      //     this.notifyMes();
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已收起',
      //     });
      //   });
      this.$notify({
        title: '通知消息',
        message: '您有一个新的控制事件',
        duration: 0,
        onClick: () => {
          this.notifyMes();
        },
        onClose: () => {
          this.$message({
            type: 'info',
            message: '已关闭通知',
          });
        },
        type: 'info',
        offset: 30,
      });
    };
    eventSource.onerror = (error) => {
      console.error(`EventSource failed: ${error}`);
      eventSource.close();
    };

    this.creatWebSocket();
  },

  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
      };
    },
  },
  methods: {
    creatWebSocket() {
      let login_name = localStorageUtil.get('username') || 'las';
      let infor = `username=${login_name}`;
      let socket = new WebSocket(this.baseUrl);
      socket.onopen = () => {
        socket.send(infor);
      };
      socket.onmessage = (event) => {
        let message = event.data;
        console.log(event.data);
        const h = this.$createElement;
        this.$notify({
          title: '提示',
          message: message,
          type: 'warning',
          duration: 0,
          customClass: 'custom-notify',
        });
      };
    },
    // 通知查看弹窗
    notifyMes() {
      this.title = '通知查看';
      this.showDialog = true;
    },

    handleCancel() {
      this.showDialog = false;
    },

    // 用户控制弹窗
    openNewDialog() {
      this.userTitle = '用户控制';
      this.userShowDialog = true;
      this.getList();
      this.tableDataSelectOptions = [];
    },
    // 控制下发
    handleSubmit() {
      const ctrlCons = this.tableDataSelectOptions.map((row) => ({
        downLoad: row.downLoad,
        id: row.id,
      }));
      HttpUrl.userControl({
        ctrlCons: ctrlCons,
        eventId: this.EventID,
      }).then((res) => {
        if (res.code == 200) {
          this.$router.push('/ancillary-services/event-calendar-assist');
          this.$message.success('下发成功!');
          this.showDialog = false;
          this.userShowDialog = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    CancelControl() {
      this.userShowDialog = false;
    },

    // 双击单元格触发事件
    doubleClick(row, column, cell, event) {
      if (column.property == 'downLoad') {
        this.startEditing(row, column);
      }
    },
    // 开始编辑
    startEditing(row, column) {
      this.$set(row, 'isEditing', true);
    },

    //自动分解
    Decomposition() {
      if (!this.IdGroup || this.IdGroup.length === 0) {
        this.$message.error('请选择用户！');
        return;
      }
      HttpUrl.getDecompositionList({
        eventId: this.EventID,
        consIds: this.IdGroup,
      }).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.allData;
          this.tableData.forEach((item) => {
            if (this.IdGroup.includes(item.id)) {
              const actionItem = res.data.actionData.find(
                (action) => action.id === item.id,
              );
              if (actionItem) {
                item.downLoad = actionItem.downLoad;
              }
            }
          });
        }
      });
    },
    // 表格多选
    selectionChange(e) {
      this.tableDataSelectOptions = e ? e : [];
    },

    //多选状态
    handleChildEvent(row) {
      this.IdGroup = row.map((val) => {
        return val.id;
      });
    },

    // 请求表格数据
    getList() {
      this.loading = true;
      HttpUrl.getUserControlList({ eventId: this.EventID }).then((res) => {
        this.tableData = res.data;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  width: 100%;
  height: calc(100% - 3rem);
}
.mainContainer-enter,
.mainContainer-leave-to {
  transform: translateX(-120rem);
  opacity: 0;
}

.mainContainer-enter-to,
.mainContainer-leave-from {
  transform: translateX(0px);
  opacity: 1;
}

.mainContainer-enter-active,
.mainContainer-leave-active {
  transition: 0.7s;
}

::v-deep .query-container .el-form-item {
  width: 21%;
}

::v-deep .query-container .el-form-item__content {
  width: calc(100% - 5.6rem);
}
::v-deep .query-container .smallcontainer {
  width: calc(21% - 2.4rem);
}
::v-deep .query-container .smallcontainer .el-form-item__content {
  width: calc(100% - 3.2rem);
}
::v-deep .query-container .bigcontainer {
  width: calc(21% + 2.6rem);
}
::v-deep .query-container .bigcontainer .el-form-item__content {
  width: calc(100% - 8.2rem);
}
</style>
